import type { GetStreamingInfoByPath200Drm } from './getStreamingInfoByPath200Drm';
import type { GetStreamingInfoByPath200MediaInfo } from './getStreamingInfoByPath200MediaInfo';
import type { GetStreamingInfoByPath200QualitiesItem } from './getStreamingInfoByPath200QualitiesItem';
import type { GetStreamingInfoByPath200Status } from './getStreamingInfoByPath200Status';
import type { GetStreamingInfoByPath200SupportedDevicesItem } from './getStreamingInfoByPath200SupportedDevicesItem';

export type GetStreamingInfoByPath200 = {
  /** DRM 정보 (있는 경우) */
  drm?: GetStreamingInfoByPath200Drm;
  /** 전체 재생 시간 (초) */
  duration?: number;
  /** HLS 버전 */
  hlsVersion?: string;
  /** 미디어 파일 기본 정보 */
  mediaInfo?: GetStreamingInfoByPath200MediaInfo;
  /** HLS 재생 목록 URL (m3u8) */
  playlistUrl?: string;
  /** 사용 가능한 품질 목록 */
  qualities?: GetStreamingInfoByPath200QualitiesItem[];
  /** 각 세그먼트 재생 시간 (초) */
  segmentDuration?: number;
  /** 스트리밍 상태 */
  status?: GetStreamingInfoByPath200Status;
  /** 스트리밍 기본 URL */
  streamUrl?: string;
  /** 스트리밍을 지원하는 장치 목록 */
  supportedDevices?: GetStreamingInfoByPath200SupportedDevicesItem[];
  /** 총 세그먼트 수 */
  totalSegments?: number;
};
